module.exports = __webpack_public_path__ + "static/media/vip_level_2.bb2ae11d.png";